import theme from '../theme'

export const sizes = {
  small: theme.container.size.small,
  medium: theme.container.size.medium,
  large: theme.container.size.large,
}

export default sizes
